'use strict';

const cache = {
    $body: $('body'),
};

module.exports = {
    initWebGLEvents: function () {
        cache.$body.on('click', '.js-3d-preview-image, .js-3d-preview-wrapper', function (e) {
            e.preventDefault();
            const $this = $(this).hasClass('js-3d-preview-image') ? $(this) : $('.js-3d-preview-image', this);
            const $wrapper = $this.closest('.js-3d-preview-wrapper');
            const w = $this.width();
            const h = $this.height();

            if ($('iframe', $wrapper).length) {
                return;
            }

            $this.addClass('d-none');
            let $iframe = $(`<iframe src="${$wrapper.attr('data-3d-url')}" width="${w}" height="${h}"></iframe>`);
            $wrapper.append($iframe);
        });

        cache.$body.on('productPersonalization:updateText', function (e, { $iframe, position, text, font, color }) {
            $iframe[0].contentWindow.postMessage(`{"view" : "CUSTOMIZED_VIEW_${position}"}`, '*');

            let message = {
                view: `CUSTOMIZED_VIEW_${position || 1}`,
                customizedFont: font,
                customizedMsg_1: text,
            };
            if (color) {
                message.embossingColor = color;
            }
            setTimeout(function () {
                $iframe[0].contentWindow.postMessage(JSON.stringify(message), '*');
            }, 300);
        });
    },
};
